import * as React from 'react';
import { ActionButton, ActionButtonGroup } from './NotificationButton.style';
import { NotificationButtonColors } from 'components/style/Colors.style';
import PropTypes from 'prop-types';

export const NotificationButtonComponent = (
  { category, onClickHandler },
  { t }
) => (
  <ActionButtonGroup>
    <ActionButton
      color={NotificationButtonColors[`${category}Icon`]}
      backgroundcolor={NotificationButtonColors[`${category}Background`]}
      onClick={onClickHandler}
      autoFocus
    >
      {t('Got it')}
    </ActionButton>
  </ActionButtonGroup>
);

NotificationButtonComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default NotificationButtonComponent;



// WEBPACK FOOTER //
// ./src/components/common/Notification/NotificationButton/NotificationButtonComponent.js